import { GridSortModel } from "@mui/x-data-grid-pro";
import { AllClaimsV2Response } from "../../../../api/claims/claimsInterfaces";
import { DealerAccount } from "../../../../api/dealer/types";
import { HeaderFilterActionPayload } from "../../../promotionsV2/PromotionDetails/type";
import { AllClaimsFilter } from "../components/allClaimsGrid/AllClaimsGrid";

export enum AllClaimsActionKind {
  SET_TAB_INDEX = "SET_TAB_INDEX",
  SET_ALL_CLAIMS_LIST = "SET_ALL_CLAIMS_LIST",
  SET_IS_LOADING = "SET_IS_LOADING",
  SET_ERROR = "SET_ERROR",
  SET_IS_CLAIMS_LOADED = "SET_IS_CLAIMS_LOADED",
  SET_PAGE_SIZE = "SET_PAGE_SIZE",
  SET_PAGE_NUMBER = "SET_PAGE_NUMBER",
  SET_FILTER = "SET_FILTER",
  SET_DATE_FILTER = "SET_DATE_FILTER",
  SET_SORT_PARAMS_ACTION = "SET_SORT_PARAMS_ACTION",
  SET_DISABLE_DOWNLOAD = "SET_DISABLE_DOWNLOAD",
  SET_SELECTED_ACCOUNTS = "SET_SELECTED_ACCOUNTS",
}

type SetTabIndexAction = {
  type: AllClaimsActionKind.SET_TAB_INDEX;
  payload: number;
};

type SetAllClaimsListActionKind = {
  type: AllClaimsActionKind.SET_ALL_CLAIMS_LIST;
  payload: AllClaimsV2Response;
};

type SetErrorAction = {
  type: AllClaimsActionKind.SET_ERROR;
  payload: any;
};

type SetIsClaimsLoadedAction = {
  type: AllClaimsActionKind.SET_IS_CLAIMS_LOADED;
  payload: boolean;
};

type SetPageSizeAction = {
  type: AllClaimsActionKind.SET_PAGE_SIZE;
  payload: number;
};

type SetPageNumberAction = {
  type: AllClaimsActionKind.SET_PAGE_NUMBER;
  payload: number;
};

type SetFilterAction = {
  type: AllClaimsActionKind.SET_FILTER;
  payload: HeaderFilterActionPayload;
};

type SetDateFilterAction = {
  type: AllClaimsActionKind.SET_DATE_FILTER;
  payload: AllClaimsFilter;
};

type SetSortParamsAction = {
  type: AllClaimsActionKind.SET_SORT_PARAMS_ACTION;
  payload: GridSortModel;
};

type SetIsLoadingAction = {
  type: AllClaimsActionKind.SET_IS_LOADING;
  payload: boolean;
};

type SetDisableDownloadAction = {
  type: AllClaimsActionKind.SET_DISABLE_DOWNLOAD;
  payload: boolean;
};

type SetSelectedAccountsAction = {
  type: AllClaimsActionKind.SET_SELECTED_ACCOUNTS;
  payload: DealerAccount[];
};

export type AllClaimsListActions =
  | SetTabIndexAction
  | SetAllClaimsListActionKind
  | SetIsLoadingAction
  | SetIsClaimsLoadedAction
  | SetErrorAction
  | SetPageSizeAction
  | SetPageNumberAction
  | SetFilterAction
  | SetDateFilterAction
  | SetSortParamsAction
  | SetDisableDownloadAction
  | SetSelectedAccountsAction;

export function setTabIndexAction(index: number): SetTabIndexAction {
  return {
    type: AllClaimsActionKind.SET_TAB_INDEX,
    payload: index,
  };
}

export function setAllClaimsListAction(
  allClaimsV2Response: AllClaimsV2Response
): SetAllClaimsListActionKind {
  return {
    type: AllClaimsActionKind.SET_ALL_CLAIMS_LIST,
    payload: allClaimsV2Response,
  };
}

export function setIsLoadingAction(isLoading: boolean): SetIsLoadingAction {
  return {
    type: AllClaimsActionKind.SET_IS_LOADING,
    payload: isLoading,
  };
}

export function setErrorAction(error: any): SetErrorAction {
  return {
    type: AllClaimsActionKind.SET_ERROR,
    payload: error,
  };
}

export function setPageNumberAction(pageNumber: number): SetPageNumberAction {
  return {
    type: AllClaimsActionKind.SET_PAGE_NUMBER,
    payload: pageNumber,
  };
}

export function setPageSizeAction(pageSize: number): SetPageSizeAction {
  return {
    type: AllClaimsActionKind.SET_PAGE_SIZE,
    payload: pageSize,
  };
}

export function setIsClaimsLoadedAction(
  isClaimsLoaded: boolean
): SetIsClaimsLoadedAction {
  return {
    type: AllClaimsActionKind.SET_IS_CLAIMS_LOADED,
    payload: isClaimsLoaded,
  };
}

export function setFilterAction(
  filter: HeaderFilterActionPayload
): SetFilterAction {
  return {
    type: AllClaimsActionKind.SET_FILTER,
    payload: filter,
  };
}

export function setDateFilterAction(filter: any): SetDateFilterAction {
  return {
    type: AllClaimsActionKind.SET_DATE_FILTER,
    payload: filter,
  };
}

export function setSortParamsAction(
  sortModel: GridSortModel
): SetSortParamsAction {
  return {
    type: AllClaimsActionKind.SET_SORT_PARAMS_ACTION,
    payload: sortModel,
  };
}

export function setDisableDownloadAction(
  downloadDisabled: boolean
): SetDisableDownloadAction {
  return {
    type: AllClaimsActionKind.SET_DISABLE_DOWNLOAD,
    payload: downloadDisabled,
  };
}

export function setSelectedAccountsAction(
  selectedAccounts: DealerAccount[]
): SetSelectedAccountsAction {
  return {
    type: AllClaimsActionKind.SET_SELECTED_ACCOUNTS,
    payload: selectedAccounts,
  };
}
